var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngularJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 43,
    viewBox: "0 0 175 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1070_1044)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1070_1044)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1070_1044)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.917 31.6394V12.2505H57.4102L69.259 27.8542V12.2505H71.629V31.6394H69.1357L57.2869 15.8821V31.6394H54.917Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9257 30.8715C89.3088 31.468 87.5979 31.7692 85.8745 31.7607C78.8602 31.7607 75.353 28.3972 75.353 21.6703C75.353 15.2988 78.7383 12.1078 85.5089 12.0975C87.3447 12.0864 89.1715 12.3563 90.9257 12.8978V15.0539C89.2878 14.4177 87.5454 14.0936 85.7883 14.0983C80.4948 14.0983 77.848 16.6217 77.848 21.6074C77.848 26.9932 80.4637 29.671 85.665 29.671C86.5975 29.6537 87.5258 29.5401 88.4351 29.3321V22.8381H90.9283V30.8706L90.9257 30.8715Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9265 24.1614V12.2505H97.4198V24.1614C97.4198 27.8853 99.2662 29.7628 102.99 29.7628C106.683 29.7628 108.56 27.8853 108.56 24.1614V12.2505H111.054V24.1614C111.054 29.2393 108.38 31.7938 102.99 31.7938C97.6 31.7938 94.9265 29.2393 94.9265 24.1614Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.009 12.2505V29.6084H128.165V31.6394H115.516V12.2505H118.009Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.766 31.6397H129.15L138.783 9.69629L148.417 31.6397H145.647L143.153 25.5458H136.752L137.429 23.5148H142.322L138.691 14.744L131.767 31.6405L131.766 31.6397Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.093 31.6394V12.2505H159.372C163.065 12.2505 164.912 13.789 164.912 16.8981C164.912 19.4215 163.096 21.2964 159.495 22.4995L166.142 31.6411H162.85L156.695 22.9307V21.299C160.388 20.7143 162.265 19.2982 162.265 17.0214C162.265 15.2362 161.249 14.3479 159.187 14.3479H153.648V31.6394H151.093Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56787 7.08118L28.419 0.00244141L48.7928 6.95785L45.5001 33.2099L28.419 42.6586L11.6148 33.3332L8.56787 7.08118Z",
    fill: "#E23237"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.793 6.95785L28.4192 0.00244141V42.6586L45.5003 33.2099L48.793 6.95785Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4494 4.98804L16.0771 32.4992L20.6937 32.413L23.1869 26.1958H34.2354L36.9434 32.4742L41.3417 32.5665L28.4494 4.98804ZM28.4805 13.8209L32.6658 22.5616H24.8178L28.4805 13.8209Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1070_1044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.712,
    height: 42.6561,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1070_1044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.712,
    height: 42.6561,
    fill: "white",
    transform: "translate(-0.000488281 0.000488281)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1070_1044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.575,
    height: 42.6561,
    fill: "white",
    transform: "translate(8.56787 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularJs);
export default __webpack_public_path__ + "static/media/angularJs.e8a9f7bd063bdd4327abde561d87981a.svg";
export { ForwardRef as ReactComponent };